import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export const LINKDIN_AUTH_URL = process.env.REACT_APP_LINKEDIN_AUTH_URL;
export const BASE_API_URL = process.env.REACT_APP_BASE_API || "http://localhost:3101";
export const BASE_URL = `${process.env.REACT_APP_BASE_API}/api` || "http://localhost:3101/api"
const ENV = process.env.REACT_APP_NODE_ENV || "development";
export const isProd = ENV === "production";

export const logger = {
	info: (message, ...args) => {
    if (isProd) return;            // or keep if you want info in prod
		console.log(`[INFO] ${message}`, ...args);
	},
	debug: (message, ...args) => {
		if (isProd) return;            // usually disable debug in prod
		console.debug(`[DEBUG] ${message}`, ...args);
	},
	log: (message, ...args) => {
		if (isProd) return;
		console.log(`[LOG] ${message}`, ...args);
	},
	error: (message, ...args) => {
		if(isProd){
			fetch(`${BASE_URL}/client-error`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ message, args }),
			});
			return;
		}
		console.error(`[ERROR] ${message}`, ...args);
	},
	warn: (message, ...args) => {
		if (isProd) return;            // or keep, your choice
		console.warn(`[WARN] ${message}`, ...args);
	},

}
export const PROFESSION_PRESETS = [
	"Game Developer",
	"Student",
	"Designer",
	"Artist",
	"Streamer",
	"Content Creator",
];

export const HOBBY_PRESETS = [
	"Coding",
	"Gaming",
	"Music",
	"Reading",
	"Chess",
	"Drawing",
	"Travel",
	"Photography",
];